// src/Sidebar.js
import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  FaTachometerAlt,
  FaShoppingCart,
  FaClipboardList,
  FaPlusSquare,
  FaWarehouse,
  FaUserTie,
  FaCog,
  FaChartLine,
  FaDollarSign,
  FaUsers,
  FaCashRegister,
  FaHistory,
  FaSignOutAlt,
  FaDesktop,
} from "react-icons/fa";
import { RiRefund2Line } from "react-icons/ri";
import "./Sidebar.css";
import { authLogout } from "./api";
import { ADMIN_LOGIN_PATH, adminPath } from "./routes";

const Sidebar = ({ isOpen, onClose, role, user }) => {
  const r = (role || user?.role || "").toLowerCase();
  const perms = user?.perms || {};
  const isAdmin = r === "admin";
  const isCashier = r === "cashier" || r === "seller";
  const anyPermOn = Object.values(perms).some((v) => !!v);

  const canSee = (permKey) => {
    if (!permKey) return true;
    if (isAdmin) {
      if (!anyPermOn) return true;
      return !perms[permKey];
    }
    if (isCashier) {
      if (!anyPermOn) return false;
      return !!perms[permKey];
    }
    return false;
  };

  const nav = useNavigate();

  const handleLogout = async () => {
    try {
      await authLogout();
    } catch (_) {
      // jim
    } finally {
      try {
        localStorage.removeItem("access");
        localStorage.removeItem("refresh");
        localStorage.removeItem("yt_user");
        localStorage.removeItem("user");
      } catch (_) {}
      nav(ADMIN_LOGIN_PATH, { replace: true });
    }
  };

  const menu = [
    { path: adminPath("dashboard"), label: "Dashboard", perm: "Dashboard", Icon: FaTachometerAlt },
    { path: adminPath("Sotuv"), label: "Sotuv", perm: "Savdo", Icon: FaShoppingCart },
    { path: adminPath("pos"), label: "POS kassa", perm: "Savdo", Icon: FaDesktop },
    { path: adminPath("CheklarTarixi"), label: "Cheklar tarixi", perm: "CheklarTarixi", Icon: FaHistory },
    { path: adminPath("Buyurtmalar"), label: "Buyurtmalar", perm: "Buyurtmalar", Icon: FaClipboardList },
    { path: adminPath("BozorTarix"), label: "Bozor tarix", perm: "BozorTarix", Icon: FaHistory },
    { path: adminPath("Vozvrat"), label: "Vozvrat", perm: "Vozvrat", Icon: RiRefund2Line },
    { path: adminPath("Ombor"), label: "Ombor", perm: "Ombor", Icon: FaWarehouse },
    { path: adminPath("Kassa"), label: "Kassa", perm: "Kassa", Icon: FaCashRegister },
    {
      path: adminPath("Hisobkitob"),
      label: "Hisob-kitob",
      perm: "Hisobkitob",
      Icon: FaChartLine,
    },
    {
      path: adminPath("accauntlar"),
      label: "Accauntlar",
      perm: "Accauntlar",
      Icon: FaUsers,
    },
    {
      path: adminPath("Maxsulotqosh"),
      label: "Maxsulot qo'shish",
      perm: "Maxsulotqosh",
      Icon: FaPlusSquare,
    },
    {
      path: adminPath("MaxsulotTarix"),
      label: "Maxsulot tarixi",
      perm: "MaxsulotTarix",
      Icon: FaHistory,
    },
    {
      path: adminPath("Sotuvchilar"),
      label: "Mijozlar",
      perm: "Mijozlar",
      Icon: FaUserTie,
    },
    { path: adminPath("Sozlamalar"), label: "Sozlamalar", perm: "Sozlamalar", Icon: FaCog },
    { path: adminPath("foyda"), label: "Foyda", perm: "Foyda", Icon: FaDollarSign },
  ];

  const username = user?.username || "Foydalanuvchi";
  const initials = username ? username[0].toUpperCase() : "?";

  return (
    <div className={`sidebar ${isOpen ? "open" : ""}`}>
      <ul>
        <li className="sidebar-user">
          <div className="sidebar-user-avatar">{initials}</div>
          <div className="sidebar-user-text">
            <span className="text">{username}</span>
          </div>
        </li>

        {menu
          .filter((item) => canSee(item.perm))
          .map(({ path, label, Icon }) => (
            <li key={path}>
              <NavLink
                to={path}
                onClick={onClose}
                title={label}
                className={({ isActive }) =>
                  "sidebar-link" + (isActive ? " active-link" : "")
                }
              >
                <span className="icon">
                  <Icon />
                </span>
                <span className="text">{label}</span>
              </NavLink>
            </li>
          ))}
      </ul>

      <div className="sidebar-footer">
        <button className="logout-btn" onClick={handleLogout}>
          <span className="icon">
            <FaSignOutAlt />
          </span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
